<script lang="ts">
	import type { PublishedPost } from "@core/schema/Post.js";
	import { toDateMonthYearFormat } from "@core/utils/toDateMonthYearFormat.js";
	import { getGlobalTemplateProps } from "../contexts/getGlobalTemplateProps.js";

	const { tenant } = getGlobalTemplateProps();
	const { post }: { post: PublishedPost } = $props();
</script>

<time datetime={post.publishedAt} class="text-sm/normal sm:text-base text-fcrgray">
	{toDateMonthYearFormat(post.publishedAt, tenant.locale)}
</time>
